// The Autor of a registro clínico as the server froze it when it was recorded
// (ClinicalAuthor#as_json): never the RUT, which only the PDFs print. `label`
// names the person the way every clinical screen does (ClinicalActorLabels:
// "Ana Pérez · TENS", "· vía Kuido · <admin>" when Kuido staff recorded it as
// the user); `inferred` marks an Autor inferido.
export type ClinicalAuthor = {
  kind: 'caregiver' | 'user' | 'system';
  name: string;
  role: string | null;
  label: string;
  inferred: boolean;
  impersonated?: boolean;
};

// Registros del sistema written by the AI: the shift summary and the text read
// from a photo.
export const SYSTEM_AI_AUTHOR: ClinicalAuthor = {
  kind: 'system', name: 'Sistema (IA)', role: null, label: 'Sistema (IA)', inferred: false,
};

// "Ana Pérez · Coordinadora · inferido"
export function clinicalAuthorName(author: ClinicalAuthor | null | undefined): string {
  if (!author) return '';

  return [author.label, author.inferred ? 'inferido' : null].filter(Boolean).join(' · ');
}

// "Registrado por Ana Pérez · Coordinadora · 21/10/2026 14:03 · inferido": the
// one format every registro clínico shows its Autor in.
export function clinicalAuthorLine(
  author: ClinicalAuthor | null | undefined,
  at?: string | null,
  label = 'Registrado por',
): string {
  if (!author) return '';

  const parts = [author.label, at, author.inferred ? 'inferido' : null];

  return `${label} ${parts.filter(Boolean).join(' · ')}`;
}

// The AI summary of a shift's reports, shown as the AI wrote it: nobody reviews
// it (PRC-01). One line names its Autor and says so.
export const AI_SUMMARY_AUTHOR_LINE = `${clinicalAuthorLine(SYSTEM_AI_AUTHOR)} · no validado por un profesional`;
